import AuthUtil from '@/util/auth-util';
import StorageUtil from '@/util/storage-util';
import React, {useCallback, useEffect, useState} from 'react';
import UserLoad from '../user-load';

const UserLogin = () => {
    const [hasLoopError, setHasLoopError] = useState(false);

    const handleJump = useCallback((checkLoopError: boolean) => {
        const getParam = () => {
            if (process.env.NODE_ENV === 'development') {
                return {
                    host: 'http://localhost:8301/auth',
                    target: 'http://localhost:8300/authorize',
                };
            } else {
                return {
                    host: 'https://smile.lanpuhu.com/auth',
                    target: 'https://sso.lanpuhu.com/authorize',
                };
            }
        };

        const loginTime = StorageUtil.getLocalItem('user-login-time') || [];
        const now = new Date().getTime();
        const save = Array.isArray(loginTime) ? loginTime.filter((i) => now - i < 5 * 1000) : [];
        if (checkLoopError && save.length >= 2) {
            setHasLoopError(true);
        } else {
            save.push(now);
            StorageUtil.setLocalItem('user-login-time', save);

            const param = getParam();
            const url = `${param.target}?code=${AuthUtil.getAppCode()}&redirect=${encodeURIComponent(param.host)}`;
            window.location.replace(url);
        }
    }, []);

    useEffect(() => {
        handleJump(true);
    }, [handleJump]);

    const handleLogin = () => {
        handleJump(false);
    };

    if (hasLoopError) {
        return <UserLoad loginHandler={handleLogin} />;
    }

    return <div />;
};

export default UserLogin;
